import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import LoadingWrapper from 'components/common/LoadingWrapper';

const PartnerSummary = ({ partner, loading, isPF }) => {
  const { t } = useTranslation();

  const getPartnerName = () =>
    isPF(partner.partnerTypeId) ? `${partner.firstName || ''} ${partner.lastName || ''}` : partner.partnerName || '';

  return (
    <Grid container alignItems={'center'}>
      <Grid item xs={loading ? 2 : undefined}>
        <LoadingWrapper loading={loading}>
          <strong>{getPartnerName()} </strong>
        </LoadingWrapper>
      </Grid>
      <Box mx={1}>{`${t('Partner.Summary.UniqueId')}`}</Box>
      <Grid item xs={loading ? 2 : undefined}>
        <LoadingWrapper loading={loading}>
          <strong>{partner.uniqueID}</strong>
        </LoadingWrapper>
      </Grid>
    </Grid>
  );
};

PartnerSummary.propTypes = {
  title: PropTypes.string.isRequired,
  partner: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  isPF: PropTypes.func.isRequired
};

export default PartnerSummary;
